import { useState } from 'react';

interface UseFormRadioGroupOptions {
    name: string;
    initialValue?: string;
    required?: boolean;
    onFirstTouch?: (name: string) => void;
}

interface UseFormRadioGroupReturn {
    name: string;
    value: string;
    onChange: (newValue: string) => void;
    valid: boolean;
}

export const useFormRadioGroup = (options: UseFormRadioGroupOptions): UseFormRadioGroupReturn => {
    const { name, initialValue = '', required = false, onFirstTouch } = options;

    const [value, setValue] = useState(initialValue);
    const [touched, setTouched] = useState(false);

    const handleChange = (newValue: string) => {
        if (!touched) {
            setTouched(true);
            onFirstTouch?.(name);
        }
        setValue(newValue);
    };

    return {
        name,
        value,
        onChange: handleChange,
        valid: required ? Boolean(value) : true,
    };
};
